import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchWpCarDetails,
  fetchMcCarDetails,
  fetchWpVendors,
  fetchRealtyHouseDetails,
} from '../store/thunks/detailsThunks';
import {
  checkIfFavorited,
  addFavorite,
  removeFavorite,
} from '../store/thunks/favoritesThunks';
import {
  replyListing,
  writeReview,
  reportListing,
  fetchCurrUser,
} from '../store/thunks/usersThunks';
import { fetchRecipientId } from '../store/thunks/vendorsThunks';
import {
  Gallery,
  LoadingSpinner,
  ModalComponent,
  ReplyToListing,
  WriteAReview,
  ReportListing,
  Rating,
  MessageIdFetcher,
  LoginModal,
  SharePost,
  Accordion,
} from './';
import moment from 'moment';
import { ColorRing } from 'react-loader-spinner';
import { GoogleMap, Marker } from '@react-google-maps/api';
import { ToastContainer, toast } from 'react-toastify';
import { LuUpload } from 'react-icons/lu';
import { IoIosSend } from 'react-icons/io';
import { FaFlag } from 'react-icons/fa6';
import { TbMessageCircleFilled } from 'react-icons/tb';
import { HiMail } from 'react-icons/hi';
import { IoSpeedometer } from 'react-icons/io5';
import { BsFillFileEarmarkCheckFill } from 'react-icons/bs';
import { RiPaintBrushFill } from 'react-icons/ri';
import { IoMdSettings } from 'react-icons/io';
import { GiCarWheel } from 'react-icons/gi';
import { MdSettingsInputHdmi } from 'react-icons/md';
import { FaCarSide } from 'react-icons/fa';
import { BsFillFuelPumpFill } from 'react-icons/bs';
import { MdFileOpen } from 'react-icons/md';
import { FaTruck } from 'react-icons/fa';
import { IoStorefront } from 'react-icons/io5';
import { FaStoreAlt } from 'react-icons/fa';
import {
  FaHeart,
  FaStar,
  FaPhoneAlt,
  FaUser,
  FaPaintBrush,
} from 'react-icons/fa';
import axios from 'axios';
import { FaBed, FaBath } from 'react-icons/fa';
import { SlSizeFullscreen } from 'react-icons/sl';
import { PiSolarRoof } from 'react-icons/pi';
import { GiHomeGarage } from 'react-icons/gi';
import { MdBalcony } from 'react-icons/md';
import { FaPersonSwimming } from 'react-icons/fa6';
import { FaRegSnowflake } from 'react-icons/fa';
import { BsFillHouseDownFill } from 'react-icons/bs';
import { FaHouseChimney } from 'react-icons/fa6';
import { GiBirdHouse } from 'react-icons/gi';
import { TbFence } from 'react-icons/tb';
import { PiPaintBrushHousehold } from 'react-icons/pi';
import { GiFireplace } from 'react-icons/gi';
import { MdCountertops } from 'react-icons/md';
import { TbDisabled } from 'react-icons/tb';
import { GiWoodenCrate } from 'react-icons/gi';
import { GiHeatHaze } from 'react-icons/gi';
import { FaHotTubPerson } from 'react-icons/fa6';
import { TbCarGarage } from 'react-icons/tb';
import { MdOutlineSecurity } from 'react-icons/md';
import { BiSolidShower } from 'react-icons/bi';
import { MdKitchen } from 'react-icons/md';
import { SiGooglecloudstorage } from 'react-icons/si';
import { GiCelebrationFire } from 'react-icons/gi';
import { FaDollarSign } from 'react-icons/fa6';
import { FaFileAlt } from 'react-icons/fa';
import { IoTime } from 'react-icons/io5';

function capitalizeFirstLetter(text) {
  if (!text) return ''; // handle empty or null input
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
}

function formatString(input) {
  return input
    .split(' ') // Split into words
    .map((word, index) => {
      // Handle "of" lowercase condition
      if (word.toLowerCase() === 'of' && index !== 0) {
        return word.toLowerCase();
      }
      // Handle hyphenated words (e.g., "mercedes-benz")
      return word
        .split('-')
        .map(
          (part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase() // Capitalize each part
        )
        .join('-'); // Rejoin hyphenated parts
    })
    .join(' '); // Rejoin all words
}

function formatPhoneNumber(phone) {
  // Format the phone number as (XXX) XXX-XXXX
  const cleaned = ('' + phone).replace(/\D/g, ''); // Remove any non-digit characters
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/); // Match groups of digits
  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`;
  }
  return phone; // Return the original phone if it doesn't match the expected pattern
}

const Detail = () => {
  const [id, setId] = useState(null);
  const [type, setType] = useState(null);

  const [isFavorited, setIsFavorited] = useState(false);
  const { user, carDetails, vendorDetails, isLoading, isFavoriteLoading } =
    useSelector((state) => state.details);
  const [activeTab, setActiveTab] = useState('details');
  const [recipientId, setRecipientId] = useState(null);
  const dispatch = useDispatch();

  /* PROPERTY FEATURES */

  // Interior Structure
  let intStructureContent;
  if (
    carDetails?.propertyInfo?.interiorStructure === null ||
    carDetails?.propertyInfo?.interiorStructure === undefined
  ) {
    intStructureContent = 'Not Provided';
  } else {
    intStructureContent = carDetails.propertyInfo.interiorStructure;
  }

  // Roof Material
  const roofMaterialsMap = {
    NULL: 'UNKNOWN OR NOT PROVIDED',
    0: 'UNKNOWN',
    101: 'UNKNOWN OR NOT PROVIDED',
    102: 'Wood Shingle',
    103: 'Shake',
    104: 'Tile',
    105: 'Composition Shingle',
    106: 'Roll Composition (rolled Mineral Roof)',
    107: 'Gravel',
    108: 'Builtup (layered Asphalt)',
    109: 'Asphalt',
    110: 'Slate',
    111: 'Aluminum',
    112: 'Metal',
    113: 'Enamel',
    114: 'Other (not Classified)',
    115: 'Asbestos',
    116: 'Roll Paper (rolled Smooth Roof)',
    117: 'Bi Metal (two-ply)',
    118: 'Heavy Composition Shingle',
    119: 'Light Composition Shingle',
    120: 'Average Composition Shingle',
    121: 'Fiberglass',
    122: 'Galvanized',
    123: 'Medium Shake',
    124: 'Bar Tile (Spanish Style)',
    125: 'Clay Tile',
    126: 'Synthetic Tile',
    127: 'Wood Shake/shingle',
    128: 'Concrete Tile',
    129: 'Rubber/elastomeric',
    130: 'Slate Tile',
    131: 'Wood',
    132: 'Hardwood',
    133: 'Wood.Wood On Steel',
    134: 'Wood',
    135: 'Flat.Wood Shake/Shingle',
    136: 'Gable.Wood Shake/Shingle',
    137: 'Hip.Wood Shake',
    138: 'Hip.Wood Shake/Shingle',
    139: 'Gambrel.Wood Shake/Shingle',
    140: 'Wood Shake',
    141: 'Cedar Shake',
    142: 'Wood Shake/Shingle.Wood Joist',
    143: 'Flat.Tile',
    144: 'Gable.Tile',
    145: 'Hip.Tile',
    146: 'Mansard.Tile',
    147: 'Shed.Tile',
    148: 'Gambrel.Tile',
    149: 'Cement Tile',
    150: 'Ceramic/Glazed Tile',
    151: 'Glazed Tile',
    152: 'A-Frame.Composition Shingle',
    153: 'Flat.Composition Shingle',
    154: 'Gable.Composition Shingle',
    155: 'Hip.Composition Shingle',
    156: 'Mansard.Composition Shingle',
    157: 'Composition',
    158: 'Shingle',
    159: 'Composition Shingle/Metal',
    160: 'Compostion Shingle',
    161: 'Flat.Composition Roll',
    162: 'Gable.Composition Roll',
    163: 'Hip.Composition Roll',
    164: 'Mansard.Composition Roll',
    165: 'Gambrel.Composition Roll',
    166: 'Composition',
    167: 'Flat.Tar & Gravel',
    168: 'Gable.Tar & Gravel',
    169: 'Hip.Tar & Gravel',
    170: 'Shed.Tar & Gravel',
    171: 'Gambrel.Tar & Gravel',
    172: 'Tar & Gravel',
    173: 'Crushed Rock',
    174: 'Gravel & Rock',
    175: 'Rock',
    176: 'Rock & Gravel',
    177: 'Stone/Rock',
    178: 'Stone/Pebble',
    179: 'Stone',
    180: 'Roll Tar & Gravel',
    181: 'Flat.Built Up.Wood',
    182: 'Built Up.Wood Joist',
    183: 'Built Up Composition',
    184: 'Built Up Gypsum',
    185: 'Built Up Metal',
    186: 'Built Up Rock',
    187: 'Built Up Tar & Gravel',
    188: 'Built Up Wood',
    189: 'Built-Up Metal/Gypsum',
    190: 'Built Up Composition/Tar & Gravel',
    191: 'Asphalt Shingle',
    192: 'Asphalt Shingle.Wood Joist',
    193: 'Asphalt Roll',
    194: 'Asphalt Tile',
    195: 'Asphalt/Composition',
    196: 'Asphalt/Composition Shingle',
    197: 'Flat',
    198: 'Flat.Slate/Slag',
    199: 'Gable.Slate/Slag',
    200: 'Hip.Slate/Slag',
    201: 'Mansard.Slate/Slag',
    202: 'Gambrel.Slate/Slag',
    203: 'Aluminum/Shingle',
    204: 'Flat.Metal',
    205: 'Flat.Copper',
    206: 'Gable.Metal',
    207: 'Gable.Steel',
    208: 'Gable.Copper',
    209: 'Hip.Metal',
    210: 'Hip.Copper',
    211: 'Mansard.Metal',
    212: 'Shed.Metal',
    213: 'Gambrel.Metal',
    214: 'Gambrel.Copper/Shingle',
    215: 'Copper',
    216: 'Copper/Shingle',
    217: 'Metal Sheeting',
    218: 'Aluminum.Steel',
    219: 'Copper/Metal',
    220: 'Corrugated Iron',
    221: 'Corrugated Metal',
    222: 'Corrugated Steel',
    223: 'Metal',
    224: 'Metal Tile',
    225: 'Metal/Shingle',
    226: 'Metal/Tar Paper',
    227: 'Metal/Tin',
    228: 'Modular Metal',
    229: 'Prefinished Metal',
    230: 'Tin',
    231: 'Corrugated Metal/Roll Roofing',
    232: 'Corrugated Metal/Tarpaper',
    233: 'Galvanized Sheet Metal.Wood Joist',
    234: 'Metal Sheeting.Steel',
    235: 'Metal Pipe',
    236: 'Copper/Enamel Metal Sheeting',
    237: 'A-Frame',
    238: 'Barn',
    239: 'Canopy',
    240: 'Dormer',
    241: 'Frame',
    242: 'Flat.Concrete',
    243: 'Flat.Wood Beam',
    244: 'Flat.Wood Truss',
    245: 'Flat.Concrete',
    246: 'Flat.Shingle',
    247: 'Gable.Concrete',
    248: 'Gable.Wood Beam',
    249: 'Gable.Wood Joist',
    250: 'Gable.Wood Truss',
    251: 'Gable',
    252: 'Gable.Shingle',
    253: 'Gable/Hip',
    254: 'Hip.Concrete',
    255: 'Hip.Wood Beam',
    256: 'Hip.Wood Joist',
    257: 'Hip.Wood Truss',
    258: 'Hip',
    259: 'Hip.Shingle',
    260: 'Geodesic',
    261: 'Mansard.Concrete',
    262: 'Mansard.Wood Beam',
    263: 'Mansard.Wood Joist',
    264: 'Mansard.Wood Truss',
    265: 'Mansard',
    266: 'Mansard.Shingle',
    267: 'Barrel',
    268: 'Monitor',
    269: 'Contemporary',
    270: 'Shed.Concrete',
    271: 'Shed.Wood Beam',
    272: 'Shed.Wood Joist',
    273: 'Shed.Wood Truss',
    274: 'Shed',
    275: 'Shed.Concrete',
    276: 'Shed.Shingle',
    277: 'Pitched.Concrete',
    278: 'Pitched',
    279: 'Pitched.Composition',
    280: 'Pyramid',
    281: 'Arched',
    282: 'Sawtooth',
    283: 'Cathedral/Clerestory',
    284: 'Bubble',
    285: 'Gambrel.Concrete',
    286: 'Gambrel.Wood Beam',
    287: 'Gambrel.Wood Joist',
    288: 'Gambrel.Wood Truss',
    289: 'Gambrel',
    290: 'Gambrel/Shingle',
    291: 'Swiss Chalet/Alpine',
    292: 'Complex/Custom',
    293: 'Butterfly',
    294: 'Gambrel/Mansard',
    295: 'Steel Joist/Mtl Deck/Slab',
    296: 'Bar Joist/Wd Joist/Sheath',
    297: 'Bar Joist',
    298: 'Concrete',
    299: 'Bar Joist & Wood Deck',
    300: 'Wood Frame',
    301: 'Bowstring',
    302: 'Bar Joist/Gyp/Wd Joist/Sheath',
    303: 'Conc Jst/Slab/Bar/Jst/Cored Pl',
    304: 'Bar Joist & Concrete Deck',
    305: 'Bar Joist/Gypsum',
    306: 'Flexible/Flexicore',
    307: 'Concrete Joist/Slab',
    308: 'Reinforced Concrete',
    309: 'Longspan Truss',
    310: 'Prestress Concrete',
    311: 'Bar Joist & Rigid Frame',
    312: 'Steel',
    313: 'Truss/Joist',
    314: 'Stl Jst/Mtl Dck/Slab/Con Jst',
    315: 'Conc Jst/Slab/Stl Jst',
    316: 'Wood Joist',
    317: 'Wood On Steel',
    318: 'Wood Truss',
    319: 'Custom',
    320: 'Concrete',
    321: 'Gypsum',
    322: 'Cement/Composition',
    323: 'Concrete Deck',
    324: 'Corrugated Composition',
    325: 'Concrete.Concrete',
    326: 'Concrete.Steel',
    327: 'Plastic/Urethane',
    328: 'Precast Concrete',
    329: 'Reinforced Concrete',
    330: 'Bermuda/Clay Tile/Wood Shingle',
    331: 'Synthetic',
    332: 'Bahama/Ceramic Tile/Blt-Up T&G',
    333: 'Shingle/Tar/Gravel/Roll Slate',
    334: 'Bermuda/Conc Pl/Bltup T&G',
    335: 'Gable/Shaped Wood Truss',
    336: 'Prestressed Concrete',
    337: 'Gable/Shaped Steel Truss',
    338: 'Wood Hip/Gable/Wood Truss',
    339: 'Gypsum.Steel',
    340: 'Shingle.Concrete',
    341: 'Irregular.Wood Truss',
    342: 'Irregular',
    343: 'Lean To',
    344: 'Salt Box',
    345: 'Dome',
    346: 'Flat.Asbestos',
    347: 'Gable.Asbestos Shingle',
    348: 'Hip.Asbestos Shingle',
    349: 'Mansard.Asbestos Shingle',
    350: 'Gambrel.Asbestos Shingle',
    351: 'Asbestos Shingle',
    352: 'Asbestos/Wood',
    353: 'Asbestos/Wood/Shingle',
    354: 'Corrugated Asbestos',
    355: 'Flat.Roll',
    356: 'Gable.Roll',
    357: 'Hip.Roll',
    358: 'Mansard.Roll',
    359: 'Shed.Roll',
    360: 'Gambrel/Roll',
    361: 'Roll',
    362: 'Tar Paper',
    363: 'Roll.Metal',
    364: 'Roll.Wood Joist',
    365: 'Tar Paper.Metal',
    366: 'Fiberglass/Plastic',
    367: 'Clay Tile/Glazed Tile',
    368: 'Clay Tile/Slate',
    369: 'Clay/Concrete Tile',
    370: 'Concrete.Truss/Joist',
    371: 'Masonite/ Cement Shake',
    372: 'Urethane',
  };

  const getRoofMaterialDescription = (code) => {
    return roofMaterialsMap[code] || 'Unknown Material';
  };

  const roofMaterialCode = carDetails?.propertyInfo?.roofMaterial || 'NULL'; // Default to "NULL" if not found
  let roofMaterialsContent;

  if (roofMaterialCode === 'NULL' || roofMaterialCode === '0') {
    roofMaterialsContent = 'Not Provided';
  } else {
    roofMaterialsContent = getRoofMaterialDescription(roofMaterialCode);
  }

  // Roof Construction
  const roofConstructionMap = {
    NULL: 'UNKNOWN OR NOT PROVIDED',
    0: 'UNKNOWN',
    101: 'DORMER',
    103: 'MONITOR',
    107: 'BARN',
    108: 'CANOPY',
    109: 'FRAME',
    113: 'GAMBREL/MANSARD',
    115: 'BUTTERFLY',
    116: 'COMPLEX/CUSTOM',
    117: 'CONTEMPORARY',
    118: 'PITCHED',
    119: 'ARCHED',
    120: 'A-FRAME',
    121: 'BUBBLE',
    124: 'BARREL',
    125: 'PYRAMID',
    126: 'SWISS CHALET/ALPINE',
    127: 'OTHER',
    197: 'FLAT',
    251: 'GABLE',
    253: 'GABLE/HIP',
    258: 'HIP',
    265: 'MANSARD',
    274: 'SHED',
    282: 'SAWTOOTH',
    283: 'CATHEDRAL/CLERESTORY',
    289: 'GAMBREL',
    311: 'Rigid Frm Bar Jt',
    312: 'Steel Frm/truss',
    313: 'Bowstring Truss',
    318: 'Wood Truss',
    320: 'Prestress Concrete',
    329: 'Reinforced Concrete',
    345: 'GEODESIC / DOME',
  };

  const getRoofConstructionDescription = (code) => {
    return roofConstructionMap[code] || 'Unknown Construction Type';
  };

  const roofConstructionCode =
    carDetails?.propertyInfo?.roofConstruction || 'NULL'; // Default to "NULL" if not found
  let roofConstructionContent;

  if (roofConstructionCode === 'NULL' || roofConstructionCode === '0') {
    roofConstructionContent = 'Not Provided';
  } else {
    roofConstructionContent =
      getRoofConstructionDescription(roofConstructionCode);
  }

  // Construction
  let constructionContent;
  if (
    carDetails?.propertyInfo?.construction === null ||
    carDetails?.propertyInfo?.construction === undefined
  ) {
    constructionContent = 'Not Provided';
  } else {
    constructionContent = carDetails.propertyInfo.construction;
  }

  // Neighborhood Type
  let neighborhoodContent;
  if (
    carDetails?.neighborhood?.type === null ||
    carDetails?.neighborhood?.type === undefined
  ) {
    neighborhoodContent = 'Not Provided';
  } else {
    neighborhoodContent = carDetails.neighborhood.type;
  }

  // Lot Info
  let lotInfoContent;
  if (
    carDetails?.lotInfo?.landUse === null ||
    carDetails?.lotInfo?.landUse === undefined
  ) {
    lotInfoContent = 'Not Provided';
  } else {
    lotInfoContent = carDetails.lotInfo.landUse;
  }

  // School
  let schoolContent;
  if (carDetails?.schools != null && carDetails?.schools.length > 0) {
    const schoolNames = carDetails?.schools.map((school) => school.name);
    schoolContent = `<ul>${schoolNames
      .map((name) => `<li>${name}</li>`)
      .join('')}</ul>`;
  } else {
    schoolContent = 'Not Provided';
  }

  const propertyAccordion = [
    { title: 'Interior Structure', content: intStructureContent },
    { title: 'Roof Materials Codes', content: roofMaterialsContent },
    { title: 'Roof Construction Codes', content: roofConstructionContent },
    { title: 'Construction Types', content: constructionContent },
    { title: 'Neighborhood Type ', content: neighborhoodContent },
    { title: 'Lot Info', content: lotInfoContent },
    { title: 'Schools', content: schoolContent },
  ];

  /* PROPERTY FEATURES ENDS */

  const mapContainerStyle = {
    width: '100%',
    height: '400px',
  };

  // LOCATION
  const defaultCenter = { lat: 0, lng: 0 }; // Fallback to some default location
  const center = {
    lat:
      parseFloat(
        carDetails?.meta?.hp_latitude ||
          carDetails?.dealer?.latitude ||
          carDetails?.propertyInfo?.latitude
      ) || defaultCenter.lat,
    lng:
      parseFloat(
        carDetails?.meta?.hp_longitude ||
          carDetails?.dealer?.longitude ||
          carDetails?.propertyInfo?.longitude
      ) || defaultCenter.lng,
  };

  // MODALS
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [isReplyToListingModalOpen, setIsReplyToListingModalOpen] =
    useState(false);
  const [isWriteAReviewModalOpen, setIsWriteAReviewModalOpen] = useState(false);
  const [isReportListingOpen, setIsReportListingOpen] = useState(false);
  const [isSendMessageOpen, setIsSendMessageOpen] = useState(false);

  const [houseImg, setHouseImg] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Function to get query parameter from URL
    const getQueryParam = (param) => {
      const queryParams = new URLSearchParams(window.location.search);
      return queryParams.get(param);
    };

    const detailId = getQueryParam('detail_id');
    const type = getQueryParam('type');
    setId(detailId);
    setType(type);

    const fetchUserData = async () => {
      try {
        const response = await dispatch(fetchCurrUser()).unwrap();
        // Check if the item is favorited
        try {
          const favoritedData = await dispatch(
            checkIfFavorited({ author: detailId, userId: response?.id })
          ).unwrap();
          setIsFavorited(favoritedData.exists);
        } catch (error) {
          console.error('Failed to check if favorited:', error);
        }
      } catch (error) {
        console.error('Failed to fetch user data:', error);
      }
    };
    fetchUserData();
    // Set a timer to stop loading after 5 seconds
    const timer = setTimeout(() => {
      setLoading(false);
    }, 5000);

    // Cleanup function to clear timer if component unmounts before the timer ends
    return () => clearTimeout(timer);
  }, [dispatch]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (
          type === 'car' ||
          type === 'motorcycle' ||
          type === 'heavy-equipment' ||
          type === 'rv'
        ) {
          await dispatch(fetchMcCarDetails({ id, type })).unwrap();
        } else if (
          type === 'housing-for-sale' ||
          type === 'housing-long-term' ||
          type === 'housing-short-term'
        ) {
          const response = await dispatch(
            fetchRealtyHouseDetails({ id, type })
          ).unwrap();
          const houseAddress =
            response?.data?.data?.propertyInfo?.address?.address;
          const fetchStreetViewImage = async () => {
            try {
              const url = 'https://maps.googleapis.com/maps/api/streetview';
              const response = await axios.get(url, {
                params: {
                  size: '600x300',
                  location: houseAddress,
                  key: process.env.REACT_APP_GOOGLE_API, // Ensure this is set in your environment variables
                },
                responseType: 'blob',
              });

              const imageBlob = URL.createObjectURL(response.data);
              setHouseImg(imageBlob);
            } catch (error) {
              console.error('Error fetching the Street View image:', error);
            } finally {
              setLoading(false);
            }
          };
          fetchStreetViewImage();
        } else {
          const response = await dispatch(fetchWpCarDetails(id)).unwrap();
          const vendorId = response?.data?.vendor_id;
          if (vendorId) {
            await dispatch(fetchWpVendors(vendorId)).unwrap();
          }
        }
      } catch (error) {
        console.error('Failed:', error);
      }
    };
    fetchData();
  }, [id, dispatch]);

  useEffect(() => {
    const fetchRecipient = async () => {
      const displayName = vendorDetails?.title?.rendered;
      const vendorId = carDetails?.id;

      try {
        const response = await dispatch(
          fetchRecipientId({ vendorId })
        ).unwrap();
        setRecipientId(response.recipient_id);
      } catch (error) {
        console.error('Failed to fetch recipient ID:', error);
      }
    };

    fetchRecipient();
  }, [vendorDetails?.slug]);

  if (isLoading || loading) {
    return (
      <LoadingSpinner
        text='Please wait...'
        height='80'
        width='80'
        strokeWidth='4'
        animationDuration='1.0'
      />
    );
  }

  // MODALS
  const openLoginModal = () => setIsLoginModalOpen(true);
  const closeLoginModal = () => setIsLoginModalOpen(false);

  const openShareModal = () => setIsShareModalOpen(true);
  const closeShareModal = () => setIsShareModalOpen(false);

  const openReplyToListingModal = () => setIsReplyToListingModalOpen(true);
  const closeReplyToListingModal = () => setIsReplyToListingModalOpen(false);

  const openWriteAReviewModal = () => setIsWriteAReviewModalOpen(true);
  const closeWriteAReviewModal = () => setIsWriteAReviewModalOpen(false);

  const openReportListingModal = () => setIsReportListingOpen(true);
  const closeReportListingModal = () => setIsReportListingOpen(false);

  const openSendMessage = () => setIsSendMessageOpen(true);
  const closeSendMessage = () => setIsSendMessageOpen(false);

  const handleViewDealerSite = (url) => {
    window.open(url, '_blank');
  };

  const handleShare = () => {
    if (navigator.share) {
      navigator
        .share({
          title: document.title,
          url: window.location.href,
        })
        .then(() => console.log('Shared successfully'))
        .catch((error) => console.error('Error sharing:', error));
    } else {
      alert('Web Share API is not supported in your browser.');
    }
  };

  const handleAddToFavorites = async () => {
    if (!id) return;
    if (user === null) {
    }

    const currentDate = new Date()
      .toISOString()
      .replace('T', ' ')
      .substring(0, 19); // Format date

    try {
      const favoritedData = await dispatch(
        addFavorite({ id, userId: user.id, currentDate, type })
      ).unwrap();
      setIsFavorited(favoritedData.exists);
    } catch (error) {
      console.error('Failed to add favorite:', error);
    }
  };

  const handleRemoveFromFavorites = async () => {
    if (!id || !user?.id) return;

    try {
      const favoritedData = await dispatch(
        removeFavorite({ author: id, userId: user.id })
      ).unwrap();
      setIsFavorited(false);
    } catch (error) {
      console.error('Failed to remove favorite:', error);
    }
  };

  const handleReply = async ({ listingId, message, attachment }) => {
    try {
      const result = await dispatch(
        replyListing({ recipientId, listingId, message, attachment })
      ).unwrap();
      toast.success('Your message has been sent.');
    } catch (error) {
      toast.warning(error);
    } finally {
      setIsReplyToListingModalOpen(false);
      setIsSendMessageOpen(false);
    }
  };

  const handleReview = async ({ listingId, rating, reviewText }) => {
    try {
      const result = await dispatch(
        writeReview({ listingId, rating, reviewText })
      ).unwrap();
      toast.success('Your review has been sent.');
    } catch (error) {
      toast.warning(error);
      console.log(error);
    } finally {
      setIsWriteAReviewModalOpen(false);
    }
  };

  const handleReport = async ({ listingId, details }) => {
    try {
      const result = await dispatch(
        reportListing({ listingId, details })
      ).unwrap();
      toast.success('Listing has been reported.');
    } catch (error) {
      toast.warning(error);
      console.log(error);
    } finally {
      setIsReportListingOpen(false);
    }
  };

  return (
    <div className='detail-container'>
      <MessageIdFetcher />
      {carDetails && (
        <div key={carDetails.id} className='detail-wrap'>
          <div className='header-wrap'>
            <div className='title-wrap'>
              <h2>
                <span
                  dangerouslySetInnerHTML={{
                    __html:
                      carDetails?.title?.rendered ||
                      carDetails?.heading ||
                      carDetails?.propertyInfo?.address?.address,
                  }}
                />
              </h2>

              <button onClick={openShareModal} className='share-btn'>
                <LuUpload size={25} />
              </button>
            </div>
            <span className='date-added'>
              ADDED ON{' '}
              {moment(
                carDetails.date_gmt ||
                  carDetails?.first_seen_at_date ||
                  carDetails?.lastUpdateDate
              ).format('MMMM DD, YYYY')}
            </span>
          </div>
        </div>
      )}

      <div className='content-wrap'>
        <div className='left'>
          <div className='tab-container'>
            <button
              className={`tab-button ${
                activeTab === 'details' ? 'active' : ''
              }`}
              onClick={() => setActiveTab('details')}
            >
              Details
            </button>
            {isFavorited ? (
              <div className='favorite-wrap'>
                {isFavoriteLoading ? (
                  <ColorRing />
                ) : (
                  <button
                    className='transparent remove'
                    onClick={handleRemoveFromFavorites}
                  >
                    <FaHeart /> Remove from Favorites
                  </button>
                )}
              </div>
            ) : (
              <div className='favorite-wrap'>
                {isFavoriteLoading ? (
                  <ColorRing />
                ) : (
                  <button
                    className='transparent'
                    onClick={() => {
                      if (user) {
                        handleAddToFavorites();
                      } else {
                        // auto-trigger the login link instead of openLoginModal
                        const loginLink = document.querySelector(
                          '.hp-menu__item--user-login, a[href="#user_login_modal"]'
                        );
                        if (loginLink) {
                          loginLink.click();
                        } else {
                          console.warn('Login link not found');
                        }
                      }
                    }}
                  >
                    <FaHeart /> Add to Favorites
                  </button>
                )}
              </div>
            )}

            {/* Add more tabs as needed */}
          </div>
          <div className='tab-content'>
            {(() => {
              if (activeTab === 'details') {
                return (
                  <>
                    {(() => {
                      if (
                        type === 'car' ||
                        type === 'motorcycle' ||
                        type === 'heavy-equipment' ||
                        type === 'rv'
                      ) {
                        return (
                          <>
                            {carDetails?.media?.photo_links?.length > 1 ? (
                              <Gallery
                                images={carDetails?.media?.photo_links}
                              />
                            ) : carDetails?.media?.photo_links?.length === 1 ? (
                              <img
                                src={`${carDetails?.media?.photo_links[0]}`}
                                alt='Car'
                                className='single-img'
                              />
                            ) : null}
                            <div className='car-info'>
                              <h3>
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: `FinditZ | ${
                                      carDetails?.dealer?.name
                                        ? formatString(carDetails.dealer.name)
                                        : ''
                                    } presents a ${carDetails?.heading}`,
                                  }}
                                />
                              </h3>

                              <div className='build'>
                                <ul>
                                  {carDetails?.miles && (
                                    <li>
                                      <IoSpeedometer size={17} />
                                      <span>
                                        <strong>Mileage:</strong>{' '}
                                        {carDetails?.miles?.toLocaleString()}{' '}
                                        miles
                                      </span>
                                    </li>
                                  )}
                                  {carDetails?.inventory_type && (
                                    <li>
                                      <BsFillFileEarmarkCheckFill size={17} />
                                      <span>
                                        <strong>Condition:</strong>{' '}
                                        {carDetails?.inventory_type}
                                      </span>
                                    </li>
                                  )}
                                  {carDetails?.interior_color && (
                                    <li>
                                      <FaPaintBrush size={17} />
                                      <span>
                                        <strong>Interior Color:</strong>{' '}
                                        {carDetails?.interior_color}
                                      </span>
                                    </li>
                                  )}
                                  {carDetails?.exterior_color && (
                                    <li>
                                      <RiPaintBrushFill size={17} />
                                      <span>
                                        <strong>Exterior Color:</strong>{' '}
                                        {carDetails?.exterior_color}
                                      </span>
                                    </li>
                                  )}
                                  {carDetails?.build?.transmission && (
                                    <li>
                                      <IoMdSettings size={17} />
                                      <span>
                                        <strong>Transmission:</strong>{' '}
                                        {carDetails?.build?.transmission}
                                      </span>
                                    </li>
                                  )}
                                  {carDetails?.build?.drivetrain && (
                                    <li>
                                      <GiCarWheel size={17} />
                                      <span>
                                        <strong>Drive:</strong>{' '}
                                        {carDetails?.build?.drivetrain}
                                      </span>
                                    </li>
                                  )}
                                  {carDetails?.build?.engine && (
                                    <li>
                                      <MdSettingsInputHdmi size={17} />
                                      <span>
                                        <strong>Engine Type:</strong>{' '}
                                        {carDetails?.build?.engine}
                                      </span>
                                    </li>
                                  )}
                                  {carDetails?.build?.body_type && (
                                    <li>
                                      <FaCarSide size={17} />
                                      <span>
                                        <strong>Body Style:</strong>{' '}
                                        {carDetails?.build?.body_type}
                                      </span>
                                    </li>
                                  )}
                                  {carDetails?.build?.fuel_type && (
                                    <li>
                                      <BsFillFuelPumpFill size={17} />
                                      <span>
                                        <strong>Fuel Type:</strong>{' '}
                                        {carDetails?.build?.fuel_type}
                                      </span>
                                    </li>
                                  )}
                                  {carDetails?.carfax_clean_title && (
                                    <li>
                                      <MdFileOpen size={17} />
                                      <span>
                                        <strong>Title Status:</strong>{' '}
                                        {!carDetails?.carfax_clean_title
                                          ? 'Not Clean'
                                          : 'Clean'}
                                      </span>
                                    </li>
                                  )}
                                </ul>
                              </div>
                              {carDetails?.extra?.high_value_features && (
                                <>
                                  <h3>
                                    <strong>Premium Features</strong>
                                  </h3>
                                  {[
                                    ...new Set(
                                      carDetails.extra.high_value_features.map(
                                        (feature) => feature.category
                                      )
                                    ),
                                  ].map((category, index, uniqueFeatures) => (
                                    <span key={index}>
                                      {category}
                                      {index !== uniqueFeatures.length - 1 &&
                                        ', '}
                                    </span>
                                  ))}
                                </>
                              )}

                              <div className='other-details'>
                                <ul>
                                  {carDetails?.dealer?.dealer_type && (
                                    <li>
                                      <IoStorefront size={17} />
                                      <span>
                                        <strong>Seller Type:</strong>{' '}
                                        {carDetails?.dealer?.dealer_type &&
                                          'Dealer'}
                                      </span>
                                    </li>
                                  )}
                                </ul>
                              </div>
                            </div>
                          </>
                        );
                      } else if (
                        type === 'housing-for-sale' ||
                        type === 'housing-long-term' ||
                        type === 'housing-short-term'
                      ) {
                        return (
                          <>
                            {houseImg ? (
                              <img
                                src={houseImg}
                                alt='House'
                                className='single-img'
                              />
                            ) : null}
                            <div className='car-info'>
                              <h3>
                                {carDetails?.propertyInfo?.address?.address}
                              </h3>
                              <div className='build'>
                                <ul>
                                  <li>
                                    <FaBed size={17} />
                                    <span>
                                      <strong>Bedroom:</strong>
                                      <br />{' '}
                                      {carDetails?.propertyInfo?.bedrooms}
                                    </span>
                                  </li>
                                  <li>
                                    <FaBath size={17} />
                                    <span>
                                      <strong>Bathrooms:</strong>
                                      <br />{' '}
                                      {carDetails?.propertyInfo?.bathrooms}
                                    </span>
                                  </li>
                                  {type && (
                                    <li>
                                      <FaHouseChimney size={17} />
                                      <span>
                                        <strong>Housing Type:</strong>
                                        <br />{' '}
                                        {type === 'housing-for-sale'
                                          ? 'For Sale'
                                          : type === 'housing-long-term'
                                          ? 'Long-Term Rental'
                                          : type === 'housing-short-term'
                                          ? 'Short-Term Rental'
                                          : null}
                                      </span>
                                    </li>
                                  )}
                                  <li>
                                    <SlSizeFullscreen size={15} />
                                    <span>
                                      <strong>Square Feet:</strong>
                                      <br />{' '}
                                      {
                                        carDetails?.propertyInfo
                                          ?.livingSquareFeet
                                      }
                                    </span>
                                  </li>
                                  <li>
                                    <FaRegSnowflake size={17} />
                                    <span>
                                      <strong>Air Conditioned:</strong>
                                      <br />
                                      {carDetails?.propertyInfo
                                        ?.airConditioningType === null
                                        ? 'None/Unknown'
                                        : [
                                            'window/acwall unit',
                                            'partial',
                                            'ac.office only',
                                          ].includes(
                                            carDetails?.propertyInfo?.airConditioningType.toLowerCase()
                                          )
                                        ? 'Window A/C'
                                        : [
                                            'central',
                                            'yes',
                                            'refrigerator',
                                            'ac.package',
                                            'other',
                                            'ac.fan cooling',
                                            'ac.chilled water',
                                            'solar',
                                          ].includes(
                                            carDetails?.propertyInfo?.airConditioningType.toLowerCase()
                                          )
                                        ? 'Central A/C'
                                        : capitalizeFirstLetter(
                                            carDetails?.propertyInfo?.airConditioningType.toLowerCase()
                                          )}
                                    </span>
                                  </li>
                                  {type === 'housing-for-sale' && (
                                    <>
                                      <li>
                                        <GiBirdHouse size={17} />
                                        <span>
                                          <strong>Attic:</strong>
                                          <br />
                                          {carDetails?.propertyInfo?.attic ===
                                          null
                                            ? 'None/Unknown'
                                            : carDetails?.propertyInfo?.attic
                                            ? 'Yes'
                                            : 'None'}
                                        </span>
                                      </li>
                                      <li>
                                        <BsFillHouseDownFill size={17} />
                                        <span>
                                          <strong>Basement:</strong>
                                          <br />
                                          {carDetails?.propertyInfo
                                            ?.basementType === null
                                            ? 'None/Unknown'
                                            : capitalizeFirstLetter(
                                                carDetails?.propertyInfo?.basementType.toLowerCase()
                                              ) === 'No basement'
                                            ? 'None'
                                            : capitalizeFirstLetter(
                                                carDetails?.propertyInfo?.basementType.toLowerCase()
                                              )}
                                        </span>
                                      </li>
                                    </>
                                  )}
                                  <li>
                                    <PiSolarRoof size={17} />
                                    <span>
                                      <strong>Deck:</strong>
                                      <br />
                                      {carDetails?.propertyInfo?.deck === null
                                        ? 'None/Unknown'
                                        : carDetails?.propertyInfo?.deck
                                        ? 'Yes'
                                        : 'None'}
                                    </span>
                                  </li>
                                  <li>
                                    <TbFence size={17} />
                                    <span>
                                      <strong>Fenced-In Yard: </strong>
                                      <br />
                                      None/Unknown
                                    </span>
                                  </li>
                                  <li>
                                    <PiPaintBrushHousehold size={17} />
                                    <span>
                                      <strong>Finished Lower Level: </strong>
                                      <br />
                                      None/Unknown
                                    </span>
                                  </li>
                                  {(type === 'housing-long-term' ||
                                    type === 'housing-short-term') && (
                                    <li>
                                      <GiCelebrationFire size={17} />
                                      <span>
                                        <strong>Fire Pit: </strong>
                                        <br />
                                        None/Unknown
                                      </span>
                                    </li>
                                  )}
                                  <li>
                                    <GiFireplace size={17} />
                                    <span>
                                      <strong>Fireplace:</strong>
                                      <br />
                                      {carDetails?.propertyInfo?.fireplace ===
                                      null
                                        ? 'None/Unknown'
                                        : carDetails?.propertyInfo?.fireplace
                                        ? 'Yes'
                                        : 'None'}
                                    </span>
                                  </li>
                                  <li>
                                    <GiHomeGarage size={17} />
                                    <span>
                                      <strong>Garage</strong>
                                      <br />
                                      {carDetails?.propertyInfo?.garageType ===
                                      null
                                        ? 'No Garage/Unknown'
                                        : [
                                            'attached (unspecified)',
                                            'attached, finished',
                                            'attached, unfinished',
                                            'garage, attached',
                                            'garage, basement',
                                            'garage, built-in',
                                          ].includes(
                                            carDetails?.propertyInfo?.garageType.toLowerCase()
                                          )
                                        ? 'Attached Garage'
                                        : [
                                            'detached, finished',
                                            'detached, unfinished',
                                          ].includes(
                                            carDetails?.propertyInfo?.garageType.toLowerCase()
                                          )
                                        ? 'Detached Garage'
                                        : [
                                            'carport (unspecified)',
                                            'covered',
                                          ].includes(
                                            carDetails?.propertyInfo?.garageType.toLowerCase()
                                          )
                                        ? 'Carport/Covered Parking'
                                        : capitalizeFirstLetter(
                                            carDetails?.propertyInfo?.garageType.toLowerCase()
                                          )}
                                    </span>
                                  </li>
                                  <li>
                                    <MdCountertops size={17} />
                                    <span>
                                      <strong>Granite Countertops: </strong>
                                      <br />
                                      None/Unknown
                                    </span>
                                  </li>
                                  <li>
                                    <TbDisabled size={20} />
                                    <span>
                                      <strong>Handicap Accessible: </strong>
                                      <br />
                                      None/Unknown
                                    </span>
                                  </li>
                                  <li>
                                    <GiWoodenCrate size={17} />
                                    <span>
                                      <strong>Hardwood Floors: </strong>
                                      <br />
                                      None/Unknown
                                    </span>
                                  </li>
                                  <li>
                                    <GiHeatHaze size={17} />
                                    <span>
                                      <strong>Heating:</strong>
                                      <br />
                                      {carDetails?.propertyInfo?.heatingType ===
                                      null
                                        ? 'None/Unknown'
                                        : carDetails?.propertyInfo?.heatingType
                                        ? 'Yes'
                                        : 'None'}
                                    </span>
                                  </li>
                                  <li>
                                    <FaHotTubPerson size={17} />
                                    <span>
                                      <strong>Hot Tub: </strong>
                                      <br />
                                      None/Unknown
                                    </span>
                                  </li>
                                  <li>
                                    <TbCarGarage size={17} />
                                    <span>
                                      <strong>Off-Street Parking: </strong>
                                      <br />
                                      None/Unknown
                                    </span>
                                  </li>
                                  <li>
                                    <MdBalcony size={17} />
                                    <span>
                                      <strong>Patio:</strong>
                                      <br />
                                      {carDetails?.propertyInfo?.patio === null
                                        ? 'None/Unknown'
                                        : carDetails?.propertyInfo?.patio
                                        ? 'Yes'
                                        : 'None'}
                                    </span>
                                  </li>
                                  <li>
                                    <FaPersonSwimming size={17} />
                                    <span>
                                      <strong>Pool</strong>
                                      <br />
                                      {carDetails?.propertyInfo?.pool === null
                                        ? 'None/Unknown'
                                        : carDetails?.propertyInfo?.pool
                                        ? 'Yes'
                                        : 'None'}
                                    </span>
                                  </li>
                                  <li>
                                    <MdOutlineSecurity size={17} />
                                    <span>
                                      <strong>Security System: </strong>
                                      <br />
                                      None/Unknown
                                    </span>
                                  </li>
                                  {type === 'housing-for-sale' && (
                                    <li>
                                      <BiSolidShower size={17} />
                                      <span>
                                        <strong>Sprinkler System: </strong>
                                        <br />
                                        {carDetails?.propertyInfo
                                          ?.safetyFireSprinklers === null
                                          ? 'None/Unknown'
                                          : carDetails?.propertyInfo
                                              ?.safetyFireSprinklers
                                          ? 'Yes'
                                          : 'None'}
                                      </span>
                                    </li>
                                  )}
                                  <li>
                                    <MdKitchen size={17} />
                                    <span>
                                      <strong>Stainless Appliances: </strong>
                                      <br />
                                      None/Unknown
                                    </span>
                                  </li>
                                  {type === 'housing-for-sale' && (
                                    <li>
                                      <SiGooglecloudstorage size={13} />
                                      <span>
                                        <strong>Storage Space: </strong>
                                        <br />
                                        None/Unknown
                                      </span>
                                    </li>
                                  )}
                                </ul>
                              </div>

                              <div className='other-details'>
                                <h3>More Property Details</h3>
                                <Accordion items={propertyAccordion} />
                              </div>
                            </div>
                          </>
                        );
                      } else {
                        return (
                          <>
                            {carDetails?.hp_listing_images?.length > 1 ? (
                              <Gallery
                                images={carDetails?.hp_listing_images || []}
                              />
                            ) : (
                              <img
                                src={carDetails?.featured_image_url}
                                alt='Car'
                                className='single-img'
                              />
                            )}
                            <div className='car-info'>
                              <h3>{carDetails?.title?.rendered}</h3>
                              <div
                                className='desc'
                                dangerouslySetInnerHTML={{
                                  __html: carDetails?.content?.rendered,
                                }}
                              />
                              <div className='build'>
                                {/*Vehicles Features*/}
                                {carDetails?.hp_listing_category?.[0] ===
                                  28928 && (
                                  <ul>
                                    {carDetails?.meta?.hp_v_details_mileage && (
                                      <li>
                                        <IoSpeedometer size={17} />
                                        <span>
                                          <strong>Mileage:</strong>{' '}
                                          {carDetails?.meta?.hp_v_details_mileage?.toLocaleString()}{' '}
                                          miles
                                        </span>
                                      </li>
                                    )}
                                    {carDetails
                                      ?.hp_listing_v_details_condition?.[0]
                                      ?.name && (
                                      <li>
                                        <BsFillFileEarmarkCheckFill size={17} />
                                        <span>
                                          <strong>Condition:</strong>{' '}
                                          {
                                            carDetails
                                              ?.hp_listing_v_details_condition?.[0]
                                              ?.name
                                          }
                                        </span>
                                      </li>
                                    )}
                                    {carDetails
                                      ?.hp_listing_v_details_interior_co?.[0]
                                      ?.name && (
                                      <li>
                                        <FaPaintBrush size={17} />
                                        <span>
                                          <strong>Interior Color:</strong>{' '}
                                          {
                                            carDetails
                                              ?.hp_listing_v_details_interior_co?.[0]
                                              ?.name
                                          }
                                        </span>
                                      </li>
                                    )}
                                    {carDetails
                                      ?.hp_listing_v_details_exterior_co?.[0]
                                      ?.name && (
                                      <li>
                                        <RiPaintBrushFill size={17} />
                                        <span>
                                          <strong>Exterior Color:</strong>{' '}
                                          {
                                            carDetails
                                              ?.hp_listing_v_details_exterior_co?.[0]
                                              ?.name
                                          }
                                        </span>
                                      </li>
                                    )}
                                    {carDetails
                                      ?.hp_listing_v_features_transmissi?.[0]
                                      ?.name && (
                                      <li>
                                        <IoMdSettings size={17} />
                                        <span>
                                          <strong>Transmission:</strong>{' '}
                                          {
                                            carDetails
                                              ?.hp_listing_v_features_transmissi?.[0]
                                              ?.name
                                          }
                                        </span>
                                      </li>
                                    )}
                                    {carDetails
                                      ?.hp_listing_v_features_drive?.[0]
                                      ?.name && (
                                      <li>
                                        <GiCarWheel size={17} />
                                        <span>
                                          <strong>Drive:</strong>{' '}
                                          {
                                            carDetails
                                              ?.hp_listing_v_features_drive?.[0]
                                              ?.name
                                          }
                                        </span>
                                      </li>
                                    )}
                                    {carDetails
                                      ?.hp_listing_v_features_engine_typ?.[0]
                                      ?.name && (
                                      <li>
                                        <MdSettingsInputHdmi size={17} />
                                        <span>
                                          <strong>Engine Type:</strong>{' '}
                                          {
                                            carDetails
                                              ?.hp_listing_v_features_engine_typ?.[0]
                                              ?.name
                                          }
                                        </span>
                                      </li>
                                    )}
                                    {carDetails
                                      ?.hp_listing_v_features_body_style?.[0]
                                      ?.name && (
                                      <li>
                                        <FaCarSide size={17} />
                                        <span>
                                          <strong>Body Style:</strong>{' '}
                                          {
                                            carDetails
                                              ?.hp_listing_v_features_body_style?.[0]
                                              ?.name
                                          }
                                        </span>
                                      </li>
                                    )}
                                    {carDetails
                                      ?.hp_listing_v_features_fuel_type?.[0]
                                      ?.name && (
                                      <li>
                                        <BsFillFuelPumpFill size={17} />
                                        <span>
                                          <strong>Fuel Type:</strong>{' '}
                                          {
                                            carDetails
                                              ?.hp_listing_v_features_fuel_type?.[0]
                                              ?.name
                                          }
                                        </span>
                                      </li>
                                    )}
                                    {carDetails
                                      ?.hp_listing_v_features_title_stat?.[0]
                                      ?.name && (
                                      <li>
                                        <MdFileOpen size={17} />
                                        <span>
                                          <strong>Title Status:</strong>{' '}
                                          {
                                            carDetails
                                              ?.hp_listing_v_features_title_stat?.[0]
                                              ?.name
                                          }
                                        </span>
                                      </li>
                                    )}
                                  </ul>
                                )}

                                {/*Housing Features*/}
                                {(carDetails?.hp_listing_category[0] ===
                                  28835 ||
                                  carDetails?.hp_listing_category[0] ===
                                    28919 ||
                                  carDetails?.hp_listing_category[0] ===
                                    28920) && (
                                  <ul>
                                    <li>
                                      <FaBed size={17} />
                                      <span>
                                        <strong>Bedroom:</strong>
                                        <br /> {carDetails?.meta?.hp_h_fs_beds}
                                      </span>
                                    </li>
                                    <li>
                                      <FaBath size={17} />
                                      <span>
                                        <strong>Bathrooms:</strong>
                                        <br /> {carDetails?.meta?.hp_h_fs_baths}
                                      </span>
                                    </li>
                                    <li>
                                      <FaHouseChimney size={17} />
                                      <span>
                                        <strong>Housing Type:</strong>
                                        <br />{' '}
                                        {carDetails?.hp_listing_category[0] ===
                                        28835
                                          ? 'For Sale'
                                          : carDetails
                                              ?.hp_listing_category[0] === 28920
                                          ? 'Long-Term Rental'
                                          : carDetails
                                              ?.hp_listing_category[0] === 28919
                                          ? 'Short-Term Rental'
                                          : null}
                                      </span>
                                    </li>
                                    <li>
                                      <SlSizeFullscreen size={15} />
                                      <span>
                                        <strong>Square Feet:</strong>
                                        <br /> {carDetails?.meta?.hp_size_sq_ft}
                                      </span>
                                    </li>
                                    <li>
                                      <FaRegSnowflake size={17} />
                                      <span>
                                        <strong>Air Conditioned:</strong>
                                        <br />
                                        {Array.isArray(
                                          carDetails?.hp_listing_h_fs_property_feature
                                        ) &&
                                        carDetails?.hp_listing_h_fs_property_feature.some(
                                          (feature) =>
                                            feature.name === 'Air Conditioning'
                                        )
                                          ? 'Central A/C'
                                          : 'None'}
                                      </span>
                                    </li>
                                    {carDetails?.hp_listing_category[0] ===
                                      28835 && (
                                      <>
                                        <li>
                                          <GiBirdHouse size={17} />
                                          <span>
                                            <strong>Attic:</strong>
                                            <br />
                                            {Array.isArray(
                                              carDetails?.hp_listing_h_fs_property_feature
                                            ) &&
                                            carDetails.hp_listing_h_fs_property_feature.some(
                                              (feature) =>
                                                feature.name === 'Attic'
                                            )
                                              ? 'Yes'
                                              : 'None'}
                                          </span>
                                        </li>
                                        <li>
                                          <BsFillHouseDownFill size={17} />
                                          <span>
                                            <strong>Basement:</strong>
                                            <br />
                                            {Array.isArray(
                                              carDetails?.hp_listing_h_fs_property_feature
                                            ) &&
                                            carDetails.hp_listing_h_fs_property_feature.some(
                                              (feature) =>
                                                feature.name === 'Basement'
                                            )
                                              ? 'Yes'
                                              : 'None'}
                                          </span>
                                        </li>
                                      </>
                                    )}
                                    <li>
                                      <PiSolarRoof size={17} />
                                      <span>
                                        <strong>Deck:</strong>
                                        <br />
                                        {Array.isArray(
                                          carDetails?.hp_listing_h_fs_property_feature
                                        ) &&
                                        carDetails.hp_listing_h_fs_property_feature.some(
                                          (feature) =>
                                            feature.name ===
                                            'Outdoor Deck/Patio'
                                        )
                                          ? 'Yes'
                                          : 'None'}
                                      </span>
                                    </li>
                                    <li>
                                      <TbFence size={17} />
                                      <span>
                                        <strong>Fenced-In Yard: </strong>
                                        <br />
                                        {Array.isArray(
                                          carDetails?.hp_listing_h_fs_property_feature
                                        ) &&
                                        carDetails.hp_listing_h_fs_property_feature.some(
                                          (feature) =>
                                            feature.name === 'Fenced-In Yard'
                                        )
                                          ? 'Yes'
                                          : 'None'}
                                      </span>
                                    </li>
                                    <li>
                                      <PiPaintBrushHousehold size={17} />
                                      <span>
                                        <strong>Finished Lower Level: </strong>
                                        <br />
                                        {Array.isArray(
                                          carDetails?.hp_listing_h_fs_property_feature
                                        ) &&
                                        carDetails.hp_listing_h_fs_property_feature.some(
                                          (feature) =>
                                            feature.name ===
                                            'Finished Lower Level'
                                        )
                                          ? 'Yes'
                                          : 'None'}
                                      </span>
                                    </li>
                                    {(carDetails?.hp_listing_category[0] ===
                                      28919 ||
                                      carDetails?.hp_listing_category[0] ===
                                        28920) && (
                                      <li>
                                        <GiCelebrationFire size={17} />
                                        <span>
                                          <strong>Fire Pit: </strong>
                                          <br />
                                          {Array.isArray(
                                            carDetails?.hp_listing_h_fs_property_feature
                                          ) &&
                                          carDetails.hp_listing_h_fs_property_feature.some(
                                            (feature) =>
                                              feature.name === 'Fire Pit'
                                          )
                                            ? 'Yes'
                                            : 'None'}
                                        </span>
                                      </li>
                                    )}
                                    <li>
                                      <GiFireplace size={17} />
                                      <span>
                                        <strong>Fireplace:</strong>
                                        <br />
                                        {Array.isArray(
                                          carDetails?.hp_listing_h_fs_property_feature
                                        ) &&
                                        carDetails.hp_listing_h_fs_property_feature.some(
                                          (feature) =>
                                            feature.name === 'Fireplace'
                                        )
                                          ? 'Yes'
                                          : 'None'}
                                      </span>
                                    </li>
                                    <li>
                                      <GiHomeGarage size={17} />
                                      <span>
                                        <strong>Garage:</strong>
                                        <br />
                                        {Array.isArray(
                                          carDetails?.hp_listing_h_fs_property_feature
                                        ) &&
                                        carDetails.hp_listing_h_fs_property_feature.some(
                                          (feature) => feature.name === 'Garage'
                                        )
                                          ? 'Yes'
                                          : 'None'}
                                      </span>
                                    </li>
                                    <li>
                                      <MdCountertops size={17} />
                                      <span>
                                        <strong>Granite Countertops:</strong>
                                        <br />
                                        {Array.isArray(
                                          carDetails?.hp_listing_h_fs_property_feature
                                        ) &&
                                        carDetails.hp_listing_h_fs_property_feature.some(
                                          (feature) =>
                                            feature.name ===
                                            'Granite Countertops'
                                        )
                                          ? 'Yes'
                                          : 'None'}
                                      </span>
                                    </li>
                                    <li>
                                      <TbDisabled size={20} />
                                      <span>
                                        <strong>Handicap Accessible:</strong>
                                        <br />
                                        {Array.isArray(
                                          carDetails?.hp_listing_h_fs_property_feature
                                        ) &&
                                        carDetails.hp_listing_h_fs_property_feature.some(
                                          (feature) =>
                                            feature.name ===
                                            'Handicap Accessible'
                                        )
                                          ? 'Yes'
                                          : 'None'}
                                      </span>
                                    </li>
                                    <li>
                                      <GiWoodenCrate size={17} />
                                      <span>
                                        <strong>Hardwood Floors:</strong>
                                        <br />
                                        {Array.isArray(
                                          carDetails?.hp_listing_h_fs_property_feature
                                        ) &&
                                        carDetails.hp_listing_h_fs_property_feature.some(
                                          (feature) =>
                                            feature.name === 'Hardwood Floors'
                                        )
                                          ? 'Yes'
                                          : 'None'}
                                      </span>
                                    </li>
                                    <li>
                                      <GiHeatHaze size={17} />
                                      <span>
                                        <strong>Heating:</strong>
                                        <br />
                                        {Array.isArray(
                                          carDetails?.hp_listing_h_fs_property_feature
                                        ) &&
                                        carDetails.hp_listing_h_fs_property_feature.some(
                                          (feature) =>
                                            feature.name === 'Heating'
                                        )
                                          ? 'Yes'
                                          : 'None'}
                                      </span>
                                    </li>
                                    <li>
                                      <FaHotTubPerson size={17} />
                                      <span>
                                        <strong>Hot Tub: </strong>
                                        <br />
                                        {Array.isArray(
                                          carDetails?.hp_listing_h_fs_property_feature
                                        ) &&
                                        carDetails.hp_listing_h_fs_property_feature.some(
                                          (feature) =>
                                            feature.name === 'Hot Tub'
                                        )
                                          ? 'Yes'
                                          : 'None'}
                                      </span>
                                    </li>
                                    <li>
                                      <TbCarGarage size={17} />
                                      <span>
                                        <strong>Off-Street Parking: </strong>
                                        <br />
                                        {Array.isArray(
                                          carDetails?.hp_listing_h_fs_property_feature
                                        ) &&
                                        carDetails.hp_listing_h_fs_property_feature.some(
                                          (feature) =>
                                            feature.name ===
                                            'Off-Street Parking'
                                        )
                                          ? 'Yes'
                                          : 'None'}
                                      </span>
                                    </li>
                                    <li>
                                      <MdBalcony size={17} />
                                      <span>
                                        <strong>Patio:</strong>
                                        <br />
                                        {Array.isArray(
                                          carDetails?.hp_listing_h_fs_property_feature
                                        ) &&
                                        carDetails.hp_listing_h_fs_property_feature.some(
                                          (feature) =>
                                            feature.name ===
                                            'Outdoor Deck/Patio'
                                        )
                                          ? 'Yes'
                                          : 'None'}
                                      </span>
                                    </li>
                                    <li>
                                      <FaPersonSwimming size={17} />
                                      <span>
                                        <strong>Pool:</strong>
                                        <br />
                                        {Array.isArray(
                                          carDetails?.hp_listing_h_fs_property_feature
                                        ) &&
                                        carDetails.hp_listing_h_fs_property_feature.some(
                                          (feature) => feature.name === 'Pool'
                                        )
                                          ? 'Yes'
                                          : 'None'}
                                      </span>
                                    </li>
                                    <li>
                                      <MdOutlineSecurity size={17} />
                                      <span>
                                        <strong>Security System:</strong>
                                        <br />
                                        {Array.isArray(
                                          carDetails?.hp_listing_h_fs_property_feature
                                        ) &&
                                        carDetails.hp_listing_h_fs_property_feature.some(
                                          (feature) =>
                                            feature.name === 'Security System'
                                        )
                                          ? 'Yes'
                                          : 'None'}
                                      </span>
                                    </li>
                                    {carDetails?.hp_listing_category[0] ===
                                      28835 && (
                                      <li>
                                        <BiSolidShower size={17} />
                                        <span>
                                          <strong>Sprinkler System:</strong>
                                          <br />
                                          {Array.isArray(
                                            carDetails?.hp_listing_h_fs_property_feature
                                          ) &&
                                          carDetails.hp_listing_h_fs_property_feature.some(
                                            (feature) =>
                                              feature.name ===
                                              'Sprinkler System'
                                          )
                                            ? 'Yes'
                                            : 'None'}
                                        </span>
                                      </li>
                                    )}
                                    <li>
                                      <MdKitchen size={17} />
                                      <span>
                                        <strong>Stainless Appliances:</strong>
                                        <br />
                                        {Array.isArray(
                                          carDetails?.hp_listing_h_fs_property_feature
                                        ) &&
                                        carDetails.hp_listing_h_fs_property_feature.some(
                                          (feature) =>
                                            feature.name ===
                                            'Stainless Appliances'
                                        )
                                          ? 'Yes'
                                          : 'None'}
                                      </span>
                                    </li>
                                    {carDetails?.hp_listing_category[0] ===
                                      28835 && (
                                      <li>
                                        <SiGooglecloudstorage size={13} />
                                        <span>
                                          <strong>Storage Space:</strong>
                                          <br />
                                          {Array.isArray(
                                            carDetails?.hp_listing_h_fs_property_feature
                                          ) &&
                                          carDetails.hp_listing_h_fs_property_feature.some(
                                            (feature) =>
                                              feature.name === 'Storage Space'
                                          )
                                            ? 'Yes'
                                            : 'None'}
                                        </span>
                                      </li>
                                    )}
                                  </ul>
                                )}

                                {/* Services Features */}
                                {[
                                  28955, 28956, 28957, 28958, 28959, 28960,
                                  28961, 28962, 28963, 28964, 28965, 28966,
                                  28967, 28968, 28969, 28970, 28977, 28971,
                                  28972, 28973, 28974, 28975,
                                ].includes(
                                  carDetails?.hp_listing_category?.[0]
                                ) && (
                                  <ul>
                                    {carDetails?.hp_listing_payment_type
                                      ?.length > 0 && (
                                      <li>
                                        <FaDollarSign size={17} />
                                        <span>
                                          <strong>Payment Type:</strong>{' '}
                                          {carDetails?.hp_listing_payment_type
                                            .map((payment) => payment?.name)
                                            .join(', ')}
                                        </span>
                                      </li>
                                    )}
                                    {carDetails?.hp_listing_warranty?.[0]
                                      ?.name && (
                                      <li>
                                        <FaFileAlt size={17} />
                                        <span>
                                          <strong>Warranty:</strong>{' '}
                                          {
                                            carDetails?.hp_listing_warranty?.[0]
                                              ?.name
                                          }
                                        </span>
                                      </li>
                                    )}
                                    {carDetails?.hp_listing_available_times
                                      ?.length > 0 && (
                                      <li>
                                        <IoTime size={17} />
                                        <span>
                                          <strong>Availability:</strong>{' '}
                                          {carDetails?.hp_listing_available_times
                                            .map((time) => time?.name)
                                            .join(', ')}
                                        </span>
                                      </li>
                                    )}
                                  </ul>
                                )}
                              </div>
                              {carDetails?.hp_listing_v_features_premium_fe && (
                                <h3>
                                  <strong>Premium Features</strong>
                                </h3>
                              )}
                              {carDetails?.hp_listing_v_features_premium_fe &&
                                carDetails.hp_listing_v_features_premium_fe.map(
                                  (feature, index) => (
                                    <span key={feature.term_id}>
                                      {feature.name}
                                      {index !==
                                        carDetails
                                          .hp_listing_v_features_premium_fe
                                          .length -
                                          1 && ', '}
                                    </span>
                                  )
                                )}
                              <div className='other-details'>
                                <ul>
                                  {carDetails
                                    ?.hp_listing_v_seller_pickup_deliv?.[0]
                                    ?.name && (
                                    <li>
                                      <FaTruck size={17} />
                                      <span>
                                        <strong>Pickup/Delivery:</strong>{' '}
                                        {
                                          carDetails
                                            ?.hp_listing_v_seller_pickup_deliv?.[0]
                                            ?.name
                                        }
                                      </span>
                                    </li>
                                  )}
                                  {carDetails
                                    ?.hp_listing_v_seller_seller_type?.[0]
                                    ?.name && (
                                    <li>
                                      <IoStorefront size={17} />
                                      <span>
                                        <strong>Seller Type:</strong>{' '}
                                        {
                                          carDetails
                                            ?.hp_listing_v_seller_seller_type?.[0]
                                            ?.name
                                        }
                                      </span>
                                    </li>
                                  )}
                                </ul>
                              </div>
                            </div>
                          </>
                        );
                      }
                    })()}
                  </>
                );
              }
            })()}

            {/* Add more tab content as needed */}
          </div>
        </div>
        <div className='right'>
          <div className='price-wrap mb-20'>
            {carDetails?.meta?.hp_price ||
            carDetails?.price ||
            carDetails?.mlsListingPrice
              ? `$${parseFloat(
                  carDetails?.meta?.hp_price ||
                    carDetails?.price ||
                    carDetails?.mlsListingPrice
                ).toLocaleString()}`
              : 'Contact dealer for price'}
          </div>
          {type === 'car' ||
          type === 'motorcycle' ||
          type === 'heavy-equipment' ||
          type === 'rv' ? (
            <button
              className='primary w-full btn-reply mb-20'
              onClick={() => handleViewDealerSite(carDetails?.vdp_url)}
            >
              <FaStoreAlt size={20} /> View Dealer Site for More Info
            </button>
          ) : type === 'housing-for-sale' ||
            type === 'housing-long-term' ||
            type === 'housing-short-term' ? null : (
            <button
              className='primary w-full btn-reply mb-20'
              onClick={user ? openReplyToListingModal : openLoginModal}
            >
              <IoIosSend size={20} /> Reply to Listing
            </button>
          )}

          {vendorDetails?.link && (
            <>
              <button
                className='transparent m-inline-auto mb-10'
                onClick={user ? openWriteAReviewModal : openLoginModal}
              >
                <FaStar /> Write a Review
              </button>
              <button
                className='transparent m-inline-auto mb-30'
                onClick={user ? openReportListingModal : openLoginModal}
              >
                <FaFlag /> Report or Improve Listing
              </button>
            </>
          )}

          <div className='vendor-wrap'>
            {vendorDetails?.link && (
              <button
                className='profile-pic'
                onClick={() => handleViewDealerSite(vendorDetails.link)}
              >
                {vendorDetails.meta?.featured_image_url ? (
                  <img
                    src={vendorDetails.meta.featured_image_url}
                    alt='Dealer Picture'
                  />
                ) : (
                  <FaUser />
                )}
              </button>
            )}
            {['car', 'motorcycle', 'heavy-equipment', 'rv'].includes(type) ? (
              <h2
                onClick={() => handleViewDealerSite(carDetails?.vdp_url)}
                className='car-dealer-name'
              >
                {carDetails?.dealer?.name
                  ? formatString(carDetails.dealer.name)
                  : ''}
              </h2>
            ) : type === 'housing-for-sale' ||
              type === 'housing-long-term' ||
              type === 'housing-short-term' ? (
              <h2 className='car-dealer-name'>
                {carDetails?.ownerInfo?.owner1FirstName
                  ? formatString(carDetails.ownerInfo.owner1FirstName)
                  : ''}{' '}
                {carDetails?.ownerInfo?.owner1LastName
                  ? formatString(carDetails.ownerInfo.owner1LastName)
                  : ''}
              </h2>
            ) : (
              <h2
                onClick={() => handleViewDealerSite(vendorDetails?.link)}
                className='car-dealer-name'
              >
                {vendorDetails?.title?.rendered
                  ? formatString(vendorDetails.title.rendered)
                  : ''}
              </h2>
            )}

            {carDetails?.dealer?.street && (
              <a
                href={`https://www.google.com/maps/place/${carDetails?.dealer?.street},${carDetails?.dealer?.city},${carDetails?.dealer?.state}`}
                target='_blank'
              >
                <span className='font-14'>
                  {carDetails?.dealer?.street}, {carDetails?.dealer?.city},{' '}
                  {carDetails?.dealer?.state}{' '}
                  {carDetails?.dealer?.zip ? carDetails.dealer.zip : ''}
                </span>
              </a>
            )}

            {carDetails?.address?.address && (
              <span className='font-14'>{carDetails?.address?.address}</span>
            )}

            {vendorDetails?.meta?.hp_store_phone && (
              <a
                href={`tel:${vendorDetails.meta.hp_store_phone}`}
                className='phone-number'
              >
                <FaPhoneAlt size={15} />
                {vendorDetails.meta.hp_store_phone}
              </a>
            )}

            {carDetails?.dealer?.phone && (
              <a
                href={`tel:${carDetails.dealer.phone}`}
                className='phone-number'
              >
                <FaPhoneAlt size={15} />
                {formatPhoneNumber(carDetails.dealer.phone)}
              </a>
            )}

            {vendorDetails?.date && (
              <span className='reg-date'>
                MEMBER SINCE{' '}
                {moment(vendorDetails?.date)
                  .format('MMMM DD, YYYY')
                  .toUpperCase()}
              </span>
            )}
            {vendorDetails?.meta?.hp_rating && (
              <div className='rating-wrap'>
                <Rating rating={parseFloat(vendorDetails?.meta?.hp_rating)} />
                <span>
                  {parseFloat(vendorDetails?.meta?.hp_rating).toFixed(1)}
                </span>
                <span>({vendorDetails?.meta?.hp_rating_count})</span>
              </div>
            )}
          </div>
          {vendorDetails?.link && (
            <>
              <button
                className='btn-msg'
                onClick={user ? openSendMessage : openLoginModal}
              >
                <TbMessageCircleFilled size={20} />
                Send Message
              </button>
            </>
          )}

          {vendorDetails?.meta?.hp_email && (
            <div className='vendor-email'>
              <span>Other Ways to Connect</span>
              <button
                onClick={() => {
                  window.location.href = `mailto:${vendorDetails.meta.hp_email}`;
                }}
              >
                <HiMail size={20} />
              </button>
            </div>
          )}

          <div className='vendor-map'>
            <GoogleMap
              mapContainerStyle={mapContainerStyle}
              zoom={15}
              center={center}
            >
              <Marker position={center} />
            </GoogleMap>
          </div>
        </div>
      </div>

      {/* MODALS */}
      <ModalComponent
        isOpen={isShareModalOpen}
        onRequestClose={closeShareModal}
        height={550}
        transY={-30}
      >
        <SharePost
          onShare={handleShare}
          image={
            carDetails?.featured_image_url ||
            carDetails?.media?.photo_links[0] ||
            houseImg
          }
        />
      </ModalComponent>

      <ModalComponent
        isOpen={isLoginModalOpen}
        onRequestClose={closeLoginModal}
        contentLabel='Get the most out of Findit Z!'
        height={220}
        transY={-100}
      >
        <LoginModal />
      </ModalComponent>

      <ModalComponent
        isOpen={isReplyToListingModalOpen}
        onRequestClose={closeReplyToListingModal}
        height={460}
        transY={-50}
        contentLabel='REPLY TO LISTING'
      >
        <ReplyToListing onReply={handleReply} />
      </ModalComponent>

      <ModalComponent
        isOpen={isWriteAReviewModalOpen}
        onRequestClose={closeWriteAReviewModal}
        height={490}
        transY={-50}
        contentLabel='WRITE A REVIEW'
      >
        <WriteAReview onReview={handleReview} />
      </ModalComponent>

      <ModalComponent
        isOpen={isReportListingOpen}
        onRequestClose={closeReportListingModal}
        height={550}
        transY={-40}
        contentLabel='Report or Improve Listing'
      >
        <ReportListing onReport={handleReport} />
      </ModalComponent>

      <ModalComponent
        isOpen={isSendMessageOpen}
        onRequestClose={closeSendMessage}
        height={460}
        transY={-50}
        contentLabel='SEND MESSAGE'
      >
        <ReplyToListing onReply={handleReply} />
      </ModalComponent>

      <ToastContainer
        position='bottom-right'
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme='dark'
      />
    </div>
  );
};

export default Detail;
